import { render } from "./EditPontajPrezentaDetail.vue?vue&type=template&id=e1a61b7e&scoped=true&ts=true"
import script from "./EditPontajPrezentaDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditPontajPrezentaDetail.ts?vue&type=script&lang=ts&external"

import "./EditPontajPrezentaDetail.vue?vue&type=style&index=0&id=e1a61b7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a61b7e"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QForm,QBtn,QTooltip,QSpinner,QMenu,QField});
